import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import AiGenerativeCleanupIcon from '@atlaskit/icon-lab/core/ai-generative-cleanup';
import { fg } from '@atlaskit/platform-feature-flags';

import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../config-items';

export const addPolish: () => EditorPluginAIConfigItem = () => ({
	key: CONFIG_ITEM_KEYS.ADD_POLISH,
	title: aiConfigItemMessages.addPolishTitle,
	description: aiConfigItemMessages.addPolishDescription,
	icon: () => <AiGenerativeCleanupIcon label="" />,
	showInRefineDropdown: true,
	/**
	 * Polish prompt doesn't exist in assistance-service, so using shorten_intent_schema.json.
	 * Once migration to convo-ai is complete, we will remove intentShemaId option.
	 */
	intentSchemaId: 'shorten_intent_schema.json',
	featureId: 'add_polish_adf',
	adfPrompt: true,
	actions: {
		empty: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
		selection: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
});

export const addPolishWithOptions: () => EditorPluginAIConfigItemWithOptions = () => ({
	config: addPolish(),
	triggers: {
		empty: {
			enabled:
				fg('platform_editor_ai_updated_adf_prompts') ||
				fg('platform_editor_ai_updated_adf_prompts_v111'),
			docMinSize: 1,
		},
		selection: { enabled: false },
	},
});
